<template>
  <div>
    <li class="service-tree-li">
      <div
        class="service-row d-flex align-items-center justify-content-between px-2 py-2  rounded"
        :class="{ 'service-row-collapsed': !isOpen && hasChildren }"
      >
        <div class="d-flex align-items-center">
          <span
            v-if="hasChildren"
            class="expander-arrow mr-2"
            tabindex="0"
            role="button"
            aria-label="Expand or collapse"
            @click.stop="toggleOpen"
          >
            <span v-if="isOpen">&#9660;</span>
            <span v-else>&#9654;</span>
          </span>
          <b-form-checkbox
            :checked="isChecked"
            class="mb-0 mr-2"
            @change="handleCheckboxChange"
          />
          <span class="service-title font-weight-bold ml-2">{{ service.name }}</span>
          <span class="badge badge-light mr-1">{{ service.service_code }}</span>
          <span class="badge badge-secondary mr-1">{{ service.service_type && service.service_type.name ? service.service_type.name : 'N/A' }}</span>
          <span class="badge badge-soft-danger mr-1">{{ service.priority }}</span>
        </div>
      </div>
      <ul
        v-if="hasChildren && isOpen"
        class="pl-3 mt-2 mb-0"
      >
        <ServiceTreeItem
          v-for="child in service.children"
          :key="child.id"
          :service="child"
          :value="value"
          @input="handleChildInput"
        />
      </ul>
    </li>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'ServiceTreeItem',
  components: { BFormCheckbox },
  props: {
    service: Object,
    value: Array,
  },
  data() { return { isOpen: false } },
  computed: {
    isChecked() {
      return (
        Array.isArray(this.value)
        && this.service
        && this.service.id !== undefined
        && this.value.includes(this.service.id)
      )
    },
    hasChildren() {
      return this.service && Array.isArray(this.service.children) && this.service.children.length > 0
    },
  },
  methods: {
    toggleOpen() { this.isOpen = !this.isOpen },

    handleCheckboxChange(checked) {
      const { id } = this.service
      let updated = Array.isArray(this.value) ? [...this.value] : []

      if (checked) {
        if (!updated.includes(id)) updated.push(id)
      } else {
        updated = updated.filter(val => val !== id)
      }

      // Emit the updated array to parent
      this.$emit('input', updated)
    },

    handleChildInput(updatedArray) {
      // When child emits input, pass it up to parent
      this.$emit('input', updatedArray)
    },

    // Optional: If you want the "select all children" functionality from your commented code:
    toggleWithChildren() {
      const collectIds = node => {
        let ids = [node.id]
        if (node.children && node.children.length) {
          node.children.forEach(child => {
            ids = ids.concat(collectIds(child))
          })
        }
        return ids
      }

      const idsToToggle = collectIds(this.service)
      let updated = Array.isArray(this.value) ? [...this.value] : []

      if (!this.isChecked) {
        // Add all ids if not already present
        idsToToggle.forEach(id => {
          if (!updated.includes(id)) updated.push(id)
        })
      } else {
        // Remove all ids
        updated = updated.filter(id => !idsToToggle.includes(id))
      }

      this.$emit('input', updated)
    },
  },
}
</script>

<style scoped>
.service-tree-li {
  list-style: none;
  margin-bottom: 0.5rem;
}
.service-row {
  cursor: pointer;
  user-select: none;
}
.service-row:hover {
  box-shadow: 0 2px 8px rgba(60,60,60,0.10);
  border-color: #d5dbdf;
}
.service-row-collapsed {
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}
.badge {
  font-size: 0.87rem;
  font-weight: 400;
  padding: 0.20em 0.6em;
}
.badge-soft-danger {
  background: #ff000012;
  color: #e64a19;
}
.badge-secondary {
  background: #f0f1f2;
  color: #58626c;
}
.badge-light {
  background: #f7f7fa;
  color: #6c757d;
}
.expander-arrow {
  width: 24px;
  color: #999;
  font-size: 1.22rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.13s;
}
.expander-arrow:hover,
.expander-arrow:focus {
  color: #1976D2;
}
.service-title {
  font-size: 1.08rem;
  font-weight: 600;
}
.service-meta {
  font-size: 0.91rem;
}
ul {
  padding-left: 0;
}
</style>
